export default __webpack_public_path__ + "static/media/kotuko.52587db3.png";